export const createAddAudioNodeConnections = (audioNodeConnectionsStore) => {
    return (audioNode, audioNoderRender, nativeAudioNode) => {
        const activeInputs = [];
        for (let i = 0; i < nativeAudioNode.numberOfInputs; i += 1) {
            activeInputs.push(new Set());
        }
        audioNodeConnectionsStore.set(audioNode, {
            activeInputs,
            outputs: new Set(),
            passiveInputs: new WeakMap(),
            renderer: audioNoderRender
        });
    };
};
//# sourceMappingURL=/build/es2018/factories/add-audio-node-connections.js.map